import { graphql } from 'react-relay';

import { MATStudentWindowPaginator_query$key } from '../../../relay/__generated__/MATStudentWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const MATStudentWindowPaginator_query = graphql`
  fragment MATStudentWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: MATStudentFilter }
    order: { type: MATStudentOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "MATStudentWindowPaginatorRefreshQuery") {
    organizationStudents(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...MATStudentConnectionDataTable_matStudentConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<MATStudentWindowPaginator_query$key>, 'fragment'>;

const MATStudentWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={MATStudentWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => (
          <Pagination {...props} pages={data.organizationStudents.pages} loadPage={loadPage} />
        ),
      })
    }
  </FragmentWindowPaginator>
);

export default MATStudentWindowPaginator;
